import * as React from 'react'
import Backdrop from '@mui/material/Backdrop'

interface Props {
  open: boolean
  onClose: () => void
  children?: React.ReactNode
}

export default function SharedBackdrop(props: Props) {
  const { open, onClose, children } = props

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={onClose}
      >
        {children}
      </Backdrop>
    </>
  )
}
